import React  from 'react'
import {Grid ,Container, Icon , GridRow, GridColumn , Menu, MenuItem ,Popup , Divider} from "semantic-ui-react";
import { Link } from 'react-router-dom';
//import useAuth from '../../hooks/useAuth';
//import { useQuery } from '@apollo/client';
//import { GETGLOBAL } from '../../../gql/global';

//import FeedVent from './FedExterior/FedExterior';
import Footer from '../Footer/Footer';
import FedExterior from '../FedExterior/FedExterior';
import FooterIn from "./FooterIn.js"


import "./FooterIn.scss";



export default function Inicio() {


const reload = () => {
    

  window.location.reload()
};

  

  return (

 
<>



<Divider/>


<div  className='footerini' >

<Link to = "/Category">
<Popup
   content={"Categorias"}
   //on='click'
   //pinned
   hideOnScroll
   trigger={<Icon name= "sitemap" color='#1e5e35'   size='large' circular  />}
 />  
 </Link>    
 <a href="whatsapp://send?text=  Hola mira esta shop local colaborativa  basada en el contacto directo por WhatsApp %20 https://lacolme.com">
<Popup
   content={"Compartir en Whatsap"}
   //on='click'
   //pinned
   hideOnScroll
   trigger={<Icon name= "share square" color='#1e5e35'   size='large' circular  />}
 />      
</a>

<Link  to = "/info" > 

<Popup
   content={"Informacion"}
   //on='click'
   //pinned
   hideOnScroll
   trigger={<Icon name= "question circle outline" color='#1e5e35'   size='large' circular  />}
 />      

</Link>


<Link to = "/Buscar">


<Popup
   content={"Buscar"}
   //on='click'
   //pinned
   hideOnScroll
   trigger={<Icon name= "search" color='#1e5e35'   size='large' circular  />}
 />      


</Link>



<Popup
   content={"Recargar"}
   //on='click'
   //pinned
   hideOnScroll
   trigger={<Icon name= "redo" color='#1e5e35'   size='large' circular onClick={reload} />}
 />      









</div>




 </>


  )


}
